module.exports = __webpack_public_path__ + "img/金属材料学4_4.4bea1a01.png";